/**
 * TEMPORARY [PERF] timing instrumentation (Build 42 latency investigation).
 *
 * Plain console lines so they show up in the Xcode / Safari Web Inspector
 * device console on TestFlight. Never logs tokens, headers or payloads.
 * Remove this module and its call sites once the latency source is known.
 */
import { useEffect, useRef } from 'react';

export function perfNow() {
  try {
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') return performance.now();
  } catch (_e) { /* fall through */ }
  return Date.now();
}

export function perfLog(tag, fields) {
  try {
    var parts = ['[PERF]' + tag];
    if (fields) {
      Object.keys(fields).forEach(function (k) {
        var v = fields[k];
        if (v === undefined || v === null || v === '') return;
        parts.push(k + '=' + (typeof v === 'number' ? Math.round(v) : v));
      });
    }
    console.log(parts.join(' '));
  } catch (_e) { /* a log must never break the app */ }
}

/**
 * Screen timing: logs [PERF][<SCREEN>][MOUNT] once on mount and
 * [PERF][<SCREEN>][READY] duration_ms=... the first time `ready` is true
 * (the screen has cleared its primary blocking loading state). `loadError`
 * marks a READY that ended in the screen's load-error state.
 */
export function useScreenPerf(screen, ready, loadError) {
  var mountRef = useRef(null);
  var readyLoggedRef = useRef(false);
  if (mountRef.current === null) mountRef.current = perfNow();

  useEffect(function () {
    perfLog('[' + screen + '][MOUNT]', { t: mountRef.current });
  }, [screen]);

  useEffect(function () {
    if (!ready || readyLoggedRef.current) return;
    readyLoggedRef.current = true;
    perfLog('[' + screen + '][READY]', { duration_ms: perfNow() - mountRef.current, load_error: loadError ? 1 : 0 });
  }, [screen, ready, loadError]);
}
